import { IBaseParams } from '@interfaces/IBaseParam';
import { callAPIContent } from '@utils/fetcher/content';
import { IParamCreateWarehouse } from './warehouse.types';

export const getListWarehouseFromAPI = (params: IBaseParams) => {
  const options = {
    method: 'GET',
    params: params,
    servicePath: 'warehouses',
    uri: 'list',
  };
  return callAPIContent(options);
};

export const getDetailWarehouseFromAPI = (idWarehouse?: number) => {
  const options = {
    method: 'GET',
    servicePath: 'warehouses',
    uri: `detail`,
    params: {
      id: idWarehouse,
    },
  };
  return callAPIContent(options);
};

export const getOptionWarehouseFromAPI = (clientId?: number) => {
  const options = {
    method: 'GET',
    servicePath: 'warehouses',
    params: {
      client_id: clientId,
    },
  };
  return callAPIContent(options);
};

export const getAllWarehouseFromAPI = (clientId?: number) => {
  const options = {
    method: 'GET',
    servicePath: 'warehouses',
    uri: 'all',
    params: {
      client_id: clientId,
    },
  };
  return callAPIContent(options);
};

export const createWarehouseFromAPI = (params: IParamCreateWarehouse) => {
  const options = {
    method: 'POST',
    params: params,
    servicePath: 'warehouses',
  };
  return callAPIContent(options);
};

export const updateWarehouseFromAPI = (params: IParamCreateWarehouse) => {
  const options = {
    method: 'PUT',
    params: params,
    servicePath: 'warehouses',
  };
  return callAPIContent(options);
};
